import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-design-layout',
  templateUrl: './new-design-layout.component.html',
  styleUrls: ['./new-design-layout.component.scss']
})
export class NewDesignLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
